/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';
import type { PaymentStateEnum } from './PaymentStateEnum';
import {
    PaymentStateEnumFromJSON,
    PaymentStateEnumFromJSONTyped,
    PaymentStateEnumToJSON,
    PaymentStateEnumToJSONTyped,
} from './PaymentStateEnum';
import type { Partner } from './Partner';
import {
    PartnerFromJSON,
    PartnerFromJSONTyped,
    PartnerToJSON,
    PartnerToJSONTyped,
} from './Partner';

/**
 * 
 * @export
 * @interface Customer
 */
export interface Customer {
    /**
     * 
     * @type {number}
     * @memberof Customer
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    identificationNumber: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    taxIdentificationNumber: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Customer
     */
    vatPayer: boolean;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    zip: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    customerNumber: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    phone: string | null;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    contactPerson: string | null;
    /**
     * 
     * @type {Partner}
     * @memberof Customer
     */
    partner: Partner | null;
    /**
     * 
     * @type {User}
     * @memberof Customer
     */
    assignedTo: User | null;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    offersState?: string | null;
    /**
     * 
     * @type {PaymentStateEnum}
     * @memberof Customer
     */
    paymentState: PaymentStateEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Customer
     */
    deleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Customer
     */
    isPayingParent: boolean;
    /**
     * 
     * @type {Customer}
     * @memberof Customer
     */
    parent?: Customer | null;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    aspeVersion?: string | null;
}



/**
 * Check if a given object implements the Customer interface.
 */
export function instanceOfCustomer(value: object): value is Customer {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('identificationNumber' in value) || value['identificationNumber'] === undefined) return false;
    if (!('taxIdentificationNumber' in value) || value['taxIdentificationNumber'] === undefined) return false;
    if (!('vatPayer' in value) || value['vatPayer'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('zip' in value) || value['zip'] === undefined) return false;
    if (!('customerNumber' in value) || value['customerNumber'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('contactPerson' in value) || value['contactPerson'] === undefined) return false;
    if (!('partner' in value) || value['partner'] === undefined) return false;
    if (!('assignedTo' in value) || value['assignedTo'] === undefined) return false;
    if (!('paymentState' in value) || value['paymentState'] === undefined) return false;
    if (!('isPayingParent' in value) || value['isPayingParent'] === undefined) return false;
    return true;
}

export function CustomerFromJSON(json: any): Customer {
    return CustomerFromJSONTyped(json, false);
}

export function CustomerFromJSONTyped(json: any, ignoreDiscriminator: boolean): Customer {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'identificationNumber': json['identificationNumber'],
        'taxIdentificationNumber': json['taxIdentificationNumber'],
        'vatPayer': json['vatPayer'],
        'country': json['country'],
        'city': json['city'],
        'street': json['street'],
        'zip': json['zip'],
        'customerNumber': json['customerNumber'],
        'email': json['email'],
        'phone': json['phone'],
        'contactPerson': json['contactPerson'],
        'partner': PartnerFromJSON(json['partner']),
        'assignedTo': UserFromJSON(json['assignedTo']),
        'offersState': json['offersState'] == null ? undefined : json['offersState'],
        'paymentState': PaymentStateEnumFromJSON(json['paymentState']),
        'deleted': json['deleted'] == null ? undefined : json['deleted'],
        'isPayingParent': json['isPayingParent'],
        'parent': json['parent'] == null ? undefined : CustomerFromJSON(json['parent']),
        'aspeVersion': json['aspeVersion'] == null ? undefined : json['aspeVersion'],
    };
}

export function CustomerToJSON(json: any): Customer {
    return CustomerToJSONTyped(json, false);
}

export function CustomerToJSONTyped(value?: Customer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'identificationNumber': value['identificationNumber'],
        'taxIdentificationNumber': value['taxIdentificationNumber'],
        'vatPayer': value['vatPayer'],
        'country': value['country'],
        'city': value['city'],
        'street': value['street'],
        'zip': value['zip'],
        'customerNumber': value['customerNumber'],
        'email': value['email'],
        'phone': value['phone'],
        'contactPerson': value['contactPerson'],
        'partner': PartnerToJSON(value['partner']),
        'assignedTo': UserToJSON(value['assignedTo']),
        'offersState': value['offersState'],
        'paymentState': PaymentStateEnumToJSON(value['paymentState']),
        'deleted': value['deleted'],
        'isPayingParent': value['isPayingParent'],
        'parent': CustomerToJSON(value['parent']),
        'aspeVersion': value['aspeVersion'],
    };
}

